import { Bell, Globe } from "lucide-react"
import { Button } from "@/components/ui/Button"
import type { Market } from "@/lib/useMarket"
import MarketSelect from "./MarketSelect"
import ProductSearch from "./ProductSearch"
import type { SidebarPage } from "../sidebarData"

type Props = {
  page: SidebarPage
  markets: Market[]
  market: Market | null
  onMarketChange: (market: Market | null) => void
}

// Top bar: the market filter as a full-height block on the left, full-height
// product search, then the bell. The page title sits below, in the page itself.
// All-markets pages show a plain block; My Work has no block.
export default function Header({ page, markets, market, onMarketChange }: Props) {
  const block =
    page.scope === "market" || page.scope === "either" ? (
      <MarketSelect markets={markets} value={market} onChange={onMarketChange} allowAll={page.scope === "either"} />
    ) : page.scope === "all" ? (
      <div className="flex h-full min-w-[180px] items-center gap-2 border-r border-border bg-muted/60 px-4 text-[13px] font-medium text-foreground">
        <Globe size={15} />
        All markets
      </div>
    ) : null

  return (
    <div className="flex h-11 flex-shrink-0 items-stretch border-b border-border bg-background">
      {block}
      <ProductSearch />
      <div className="flex items-center px-3">
        <Button variant="outline" size="icon" aria-label="Notifications" className="h-7 w-7 bg-muted">
          <Bell size={14} />
        </Button>
      </div>
    </div>
  )
}
